const StickyHeader = () => {
    const header = document.querySelector('.site-header');
    if (!header) {
        return;
    }
    const scrollUp = 'scroll-up';
    const scrollDown = 'scroll-down';
    const offset = 60;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll === 0) {
            header.classList.remove(scrollUp);
            return;
        }

        const isScrollDown = header.classList.contains(scrollDown);

        if (currentScroll >= offset && currentScroll > lastScroll && !isScrollDown) {
            // down
            header.classList.remove(scrollUp);
            header.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && isScrollDown) {
            // up
            header.classList.remove(scrollDown);
            header.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
    });
};
export default StickyHeader;
